import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./redux/store";
import { BrowserRouter, Scripts } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import TagManager from "react-gtm-module";
import ReactPixel from "react-facebook-pixel";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-phone-input-2/lib/style.css";
import "react-casino-roulette/dist/index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";
import { weekdays } from "moment";

const tagManagerArgs = {
  gtmId: "GTM-P88BFDL6",
};

TagManager.initialize(tagManagerArgs);

const pixelOptions = {
  autoConfig: true,
  debug: false,
};

const advancedMatching = {
  test_event_code: "TEST108",
};

ReactPixel.init("3613095402326541", advancedMatching, pixelOptions);
ReactPixel.pageView();

 





const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ToastContainer />
      <App />
    </BrowserRouter>
  </Provider>
);
